import React from 'react';

function Link({ stroke, ...props }) {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.09941 5.0203L10.4916 3.62811C11.081 3.09087 11.8548 2.8014 12.6521 2.81986C13.4495 2.83832 14.209 3.16329 14.773 3.72723C15.3369 4.29117 15.6619 5.05072 15.6803 5.84805C15.6988 6.64537 15.4093 7.41914 14.8721 8.00858L12.8822 9.99139C12.5954 10.2792 12.2547 10.5076 11.8794 10.6635C11.5042 10.8193 11.1018 10.8996 10.6955 10.8996C10.2892 10.8996 9.88686 10.8193 9.51161 10.6635C9.13636 10.5076 8.79557 10.2792 8.50879 9.99139"
        fill="none"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.90107 12.9797L8.50889 14.3719C7.91945 14.9091 7.14567 15.1986 6.34835 15.1801C5.55103 15.1617 4.79148 14.8367 4.22753 14.2728C3.66359 13.7088 3.33863 12.9493 3.32017 12.1519C3.30171 11.3546 3.59118 10.5808 4.12842 9.99141L6.11826 8.0086C6.40504 7.72075 6.74583 7.49235 7.12108 7.3365C7.49633 7.18066 7.89865 7.10043 8.30498 7.10043C8.7113 7.10043 9.11363 7.18066 9.48888 7.3365C9.86413 7.49235 10.2049 7.72075 10.4917 8.0086"
        fill="none"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Link;
